/**  订单属性配置   目前未做价格 适配  后期需要做价格适配 ，资源配置交由后台获取**/


const order = {
  message: {
    defaultOrderCheck: "订单一共{price}元，是否确认购买？",
    qbOrderCheck: "订单一共{price}Q币，是否确认购买？"

  },
  activ: {
    options: [
      { label: "激活", code: 1 },
      { label: "暂不激活", code: 0 }
    ],
    map: {
      1: "激活",
      0: "未激活"
    }
  },
  function: {
    free: {
      options: [
        { label: "单呼", value: "SINGLE" },
        { label: "好友", value: "FRIEND" },
        { label: "建组", value: "TERMINAL_GROUP" },
        { label: "多呼", value: "CALL_MORE" },
        { label: "监听", value: "MONITOR" },
        { label: "广播", value: "BROADCAST" },
        { label: "视频", value: "VIDEO" }
      ],
      map: {
        "SINGLE": "单呼",
        "FRIEND": "好友",
        "TERMINAL_GROUP": "建组",
        "CALL_MORE": "多呼",
        "MONITOR": "监听",
      }
    },
    pay:{
      map: {
        "LOCATION": "定位",
        "RECORD": "录音",
        "SINGLE": "单呼",
        "FRIEND": "好友",
        "TERMINAL_GROUP": "建组",
        "CALL_MORE": "多呼",
        "MONITOR": "监听",
        "DISPATCH": "调度",
        "F2F": "面对面建群",

      }
    },
    options: [
      { label: "对讲", code: "TALKIE" },
      { label: "定位", code: "LOCATION" },
      { label: "录音", code: "RECORD" },
      { label: "调度", code: "DISPATCH" },
      { label: "面对面建群", code: "F2F" }
    ],
    map: {
      "TALKIE": "对讲",
      "LOCATION": "定位",
      "RECORD": "录音",
      "SINGLE": "单呼",
      "FRIEND": "好友",
      "TERMINAL_GROUP": "建组",
      "CALL_MORE": "多呼",
      "MONITOR": "监听",
      "DISPATCH": "调度",
      "F2F": "面对面建群",
  

    }
  },
  operationType: {
    options: [
      { label: "购买订单", code: "CREATE" },
      { label: "续签订单", code: "RENEW" },
      { label: "改签订单", code: "CHANGE" },
      { label: "拆分订单", code: "SPLIT" },
      { label: "激活订单", code: "ACTIVE" }
    ],
    map: {
      "CREATE": "购买订单",
      "RENEW": "续签订单",
      "ADDFUNC": "基本订单",
      "CHANGE": "改签订单",
      "SPLIT": "拆分订单",
      "ACTIVE": "激活订单",
    }
  },
  OrderUserType:{
    options: [
      { label: "绑定订单", code: "BIND" },
      { label: "解绑订单", code: "RELIEVE" },
    ],
    map: {
      "RELIEVE": "解绑订单",
      "BIND": "绑定订单",
    }
  },
  //订单类型
  orderType: {
    options: [
      { label: "基本订单", code: "GENERAL" },
      { label: "对讲订单", code: "QB" }
    ],
    map: {
      "GENERAL": "基本订单",
      "QB": "Q币对讲订单"
    }
  },
  // 订单时限 与其他属性不一样 该code  == 几个月
  timeLimit: {
    qb: {
      options: [
        { label: "1年", code: 12 },
        { label: "2年", code: 24 },
        { label: "3年", code: 36 },
        { label: "5年", code: 60 }
      ]
    },
    location:{
      options: [
        { label: "7天", code: 0 },
        { label: "1个月", code: 1 },
        { label: "3个月", code: 3 },
        { label: "6个月", code: 6 },
        { label: "一年", code: 12 },
      ]
    },
    record:{
      options: [
        { label: "1个月", code: 1 },
        { label: "3个月", code: 3 },
        { label: "6个月", code: 6 },
        { label: "一年", code: 12 },
      ]
    },
    options: [
      { label: "1年", code: 12 },
      { label: "2年", code: 24 },
      { label: "3年", code: 36 },
      { label: "5年", code: 60 },
      { label: "1个月", code: 1 },
      { label: "3个月", code: 3 },
      { label: "6个月", code: 6 },
      { label: "9个月", code: 9 }
    ],
    map: {
      0:"7天",
      1: "1个月",
      3: "3个月",
      6: "6个月",
      9: "9个月",
      12: "1年",
      24: "2年",
      36: "3年",
      60: "5年"
    },

  },
  priceType:{
    YEAR:'年',
    MONTH:'月',
    DAY:'天',
    OTHER:'其他',
  },
  funcLabel:{
    TALKIE:'对讲',
    SINGLE:'单呼',
    LOCATION:'定位',
    FRIEND:'好友',
    RECORD:'录音',
    TERMINAL_GROUP:'终端群组',
    CALL_MORE:'多呼',
    MONITOR:'监听',
    DISPATCH:'调度',
    BROADCAST:'广播',
    F2F: "面对面建群",
    VIDEO: "视频",
    

  },
  orderStrategy:{
    BUY:'购买订单',
    RENEW:'续签订单',
    ADD:'添加功能',
  },

  recordStorageLimit:{
    map:{
      1:"1个月",
      3:"3个月",
      6:"半年",
      12:"一年",
    }
  },
  locationStorageLimit:{
    map:{
      0:"7天",
      1:"1个月",
      3:"3个月",
      6:"半年",
      12:"一年",
    }
  },
  status: {
    options: [
      { label: "暂未激活", code: 0 },
      { label: "已激活", code: 1 }
    ],
    map: {
      0: "暂未激活",
      1: "已激活"
    }
  }
};


export default order;



// WEBPACK FOOTER //
// ./src/api/lang/modules/order/order_en.js